module.exports = __webpack_public_path__ + "static/api-0c028d13e7efbb52577e71a23bfaac5c.webp";